import { Box } from "@mui/material";
import { styled, type Theme } from "@mui/material/styles";
import { format } from "date-fns";
import type { NotificationStatus } from "./NotificationsDropdown.types";

export const AnchorStyled = styled(Box)({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
});

export const getNotificationsHeaderStyle = (theme: Theme) => ({
  fontWeight: theme.typography?.fontWeightMedium ?? 500,
  fontSize: 16,
  letterSpacing: 0,
  color: theme.palette?.text?.primary ?? "#333",
});

export const getNotificationItemTitleStyle = (theme: Theme) => ({
  letterSpacing: 0,
  color: theme.palette?.text?.primary ?? "#333",
});

export const getStatusChipSx = (theme: Theme, status: NotificationStatus) => {
  const bgByStatus: Record<NotificationStatus, string> = {
    "Pending": theme.palette.warning.main,
    "Suspend": theme.palette.custom.main,
    "Unsuspend": theme.palette.custom.secondary,
    "Expired": theme.palette.error.main,
    "Document about to expire": theme.palette.warning.main,
    "Expiring soon": theme.palette.warning.main,
    "Expires today": theme.palette.warning.main,
    "Cancelled": theme.palette.error.main,
    "Approved": theme.palette.success.main,
    "Completed": theme.palette.success.main,
    "Resubmit": theme.palette.error.main,
    "Delegated": theme.palette.info.main,
    "Permanently rejected": theme.palette.error.main,
    "Restricted": theme.palette.custom.main,
    "Clear to operate": theme.palette.custom.secondary,
    "Updated": theme.palette.info.main,
    "Closed": theme.palette.success.main,
    "Vessel Call Closed": theme.palette.success.main,
    "Dispute": theme.palette.error.main,
    "Verified": theme.palette.warning.main,
    "Rejected by Marine Department": theme.palette.error.main,
    "Rejected by Customs": theme.palette.error.main,
    "Customs Payment Required": theme.palette.warning.main,
    "Autogenerated": theme.palette.success.main,
    "Pending Approval": theme.palette.warning.main,
    "Pending Pre-approval": theme.palette.warning.main,
    "Submitted": theme.palette.info.main,
    "Interrupted In-Port": theme.palette.error.main,
    "Interrupted Leave-Port": theme.palette.error.main,
    "Rejected": theme.palette.error.main,
    "Payment Required": theme.palette.error.main,
    "Reinstated": theme.palette.success.main,
  };
  return {
    "bgcolor": bgByStatus[status],
    "color": theme.palette.text.white,
    "px": 0,
    "height": 24,
    ".MuiChip-label": { paddingLeft: "0.5rem", paddingRight: "0.5rem" },
  };
};

export function formatDate(iso?: string | null) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return format(d, "dd/MM/yyyy HH:mm");
}
